<script lang="ts">
  export let width: string = '100%';
  export let height: string = '0.75 rem';
  export let borderRadius: string = '0.313rem';
  export let paddingTop: string = '0';
  export let paddingBottom: string = '0';
  export let paddingLeft: string = '0';
  export let paddingRight: string = '0';
  export let lightBackground: boolean = true;
  export let marginBottom: string = '0';
  export let marginLeft: string = '0';
  export let marginRight: string = '0';
</script>

<div
  class="ngx-shimmer"
  class:light-background={lightBackground}
  class:dark-background={!lightBackground}
  style="width: {width}; height: {height}; border-radius: {borderRadius}; padding-top: {paddingTop}; padding-bottom: {paddingBottom}; padding-left: {paddingLeft}; padding-right: {paddingRight}; margin-bottom: {marginBottom}; margin-left: {marginLeft}; margin-right: {marginRight};"
></div>

<style lang="scss">
  @import '../../../../variables.scss';
  :host {
    padding: 0;
    margin: 0;
    display: block;
  }
  .ngx-shimmer {
    display: block;
    width: 100%;
  }

  .light-background {
    background-color: $shimmer-color;
  }

  .dark-background {
    background-color: rgb(48, 54, 61);
  }
</style>
